import {
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import TopViewNav from "../../CommonComponents/TopViewNav";
import EditIcon from "@mui/icons-material/Edit";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import CloseIcon from "@mui/icons-material/Close";
import { dynamiceForm } from "../../../actions/DynamiceForm";
import "./AddHeader.css";
import { useNavigate } from "react-router-dom";

const Meetingheader = [
  {
    Sno: 1,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Date",
    name: "Date",
    url: null,
    order: 1,
  },
  {
    Sno: 2,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Meeting Start Time",
    name: "Meeting Start Time",
    url: null,
    order: 2,
  },
  {
    Sno: 3,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Meeting End Time",
    name: "Meeting End Time",
    url: null,
    order: 3,
  },
  {
    Sno: 4,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Meeting Start Location",
    name: "Meeting Start Location",
    url: null,
    order: 4,
  },
  {
    Sno: 5,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Meeting End Location",
    name: "Meeting End Location",
    url: null,
    order: 5,
  },
  {
    Sno: 6,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Meeting Duration",
    name: "Meeting Duration",
    url: null,
    order: 6,
  },
  {
    Sno: 7,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Emp Name(Emp Code)",
    name: "Emp Name(Emp Code)",
    url: null,
    order: 7,
  },
  {
    Sno: 8,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Vendor/Client/Other",
    name: "Vendor/Client/Other",
    url: null,
    order: 8,
  },
  {
    Sno: 9,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Client Status",
    name: "Client Status",
    url: null,
    order: 9,
  },
  {
    Sno: 10,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Website",
    name: "Website",
    url: null,
    order: 10,
  },
  {
    Sno: 11,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Relationship Type",
    name: "Relationship Type",
    url: null,
    order: 11,
  },
  {
    Sno: 12,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Person Name",
    name: "Person Name",
    url: null,
    order: 12,
  },
  {
    Sno: 13,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Contact Number",
    name: "Contact Number",
    url: null,
    order: 13,
  },
  {
    Sno: 14,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Meeting Type",
    name: "Meeting Type",
    url: null,
    order: 14,
  },
  {
    Sno: 15,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Discussion Detail",
    name: "Discussion Detail",
    url: null,
    order: 15,
  },
  {
    Sno: 16,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Remarks",
    name: "Remarks",
    url: null,
    order: 16,
  },
  {
    Sno: 17,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Distance",
    name: "Distance",
    url: null,
    order: 17,
  },
  {
    Sno: 18,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Meeting Distance Fare (Rs)",
    name: "Meeting Distance Fare (Rs)",
    url: null,
    order: 18,
  },
  {
    Sno: 19,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Meeting Expense Amount (Rs)",
    name: "Meeting Expense Amount (Rs)",
    url: null,
    order: 19,
  },
  {
    Sno: 20,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Total Distance(Kms)",
    name: "Total Distance(Kms)",
    url: null,
    order: 20,
  },
  {
    Sno: 21,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Daily Distance Fare (Rs)",
    name: "Daily Distance Fare (Rs)",
    url: null,
    order: 21,
  },
  {
    Sno: 22,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Total Expense (Rs)",
    name: "Total Expense (Rs)",
    url: null,
    order: 22,
  },
  {
    Sno: 23,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Total Amount(Rs)",
    name: "Total Amount(Rs)",
    url: null,
    order: 23,
  },
];
const clientHeader = [
  {
    Sno: 1,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "S.No",
    name: "S.No",
    url: null,
    order: 1,
  },
  {
    Sno: 2,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Created Date",
    name: "Created Date",
    url: null,
    order: 2,
  },
  {
    Sno: 3,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Client Name",
    name: "Client Name",
    url: null,
    order: 3,
  },
  {
    Sno: 4,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Client Status",
    name: "Client Status",
    url: null,
    order: 4,
  },
  {
    Sno: 5,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Contact Person",
    name: "Contact Person",
    url: null,
    order: 5,
  },
  {
    Sno: 6,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Phone Number",
    name: "Phone Number",
    url: null,
    order: 6,
  },
  {
    Sno: 7,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Email",
    name: "Email",
    url: null,
    order: 7,
  },
  {
    Sno: 8,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Client Owner",
    name: "Client Owner",
    url: null,
    order: 8,
  },
  {
    Sno: 9,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Last Meeting Date",
    name: "Last Meeting Date",
    url: null,
    order: 9,
  },
  {
    Sno: 10,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Last meeting by",
    name: "Last meeting by",
    url: null,
    order: 10,
  },
  {
    Sno: 11,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Total Meetings",
    name: "Total Meetings",
    url: null,
    order: 11,
  },
  {
    Sno: 12,
    forMobile: true,
    forWeb: true,
    id: 1,
    isActive: true,
    keyName: "Details",
    name: "Details",
    url: null,
    order: 12,
  },
];

function AddHeader() {
  const navigate = useNavigate();
  const [headername, setHeadername] = useState("");
  const [editeValue, setEditValue] = useState(null);
  const [showEditValue, setShowEdite] = useState(false);
  const [sortedList, setSortedList] = useState([]);
  const [showCompname, setShowCompamyName] = useState(
    JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
      JSON.parse(localStorage.getItem("CompanyIdSelect")).CompanyName
  );

  const getOnchangevalue1 = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal1 = [...sortedList];
    onchangeVal1[i][name] = e.target.checked;
    setSortedList(onchangeVal1);
  };
  const getOnchangevalue = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal = [...sortedList];
    onchangeVal[i][name] = value;
    setSortedList(onchangeVal);
  };

  const fetchComapnyHeaderList = () => {
    const subTemplateTypeId = JSON.parse(localStorage.getItem("subTemplateId"));
    const data = {
      headerMasterId: window.location.pathname === "/AddHeader/client" ? 1 : 2,
      companyId:
        JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
        JSON.parse(localStorage.getItem("CompanyIdSelect")).id,
      siteId: JSON.parse(localStorage.getItem("CompanyIdSelect"))?.site
        ? JSON.parse(localStorage.getItem("CompanyIdSelect"))?.site?.id
        : null,
      subTemplateTypeId,
    };
    dynamiceForm.fetchCompanyHeader(data).then((response) => {
      if (response !== null) {
        setSortedList(
          Boolean(response?.data?.length > 0)
            ? response?.data?.map((item) => ({ ...item, subTemplateTypeId }))
            : []
        );
      }
    });
  };

  const fetchCompanyUpdateList = () => {
    dynamiceForm.fetchCompanyHeaderUpdate(sortedList).then((response) => {
      if (response !== null) {
        fetchComapnyHeaderList();
        setShowEdite(false);
        setEditValue(null);
        alert("Update Successfully");
      }
    });
  };

  // let sourceElement = null
  // const handleDragStart = (event) => {
  //     event.target.style.opacity = 0.5
  //     sourceElement = event.target
  //     event.dataTransfer.effectAllowed = 'move'
  // }

  // /* do not trigger default event of item while passing (e.g. a link) */
  // const handleDragOver = (event) => {
  //     event.preventDefault()
  //     event.dataTransfer.dropEffect = 'move'
  // }

  // /* add class .over while hovering other items */
  // const handleDragEnter = (event) => {
  //     event.target.classList.add('over')
  // }

  // /* remove class .over when not hovering over an item anymore*/
  // const handleDragLeave = (event) => {
  //     event.target.classList.remove('over')
  // }

  // const handleDrop = (event) => {

  //     /* prevent redirect in some browsers*/
  //     event.stopPropagation()

  //     /* only do something if the dropped on item is
  //     different to the dragged item*/
  //     if (sourceElement !== event.target) {

  //         /* remove dragged item from list */
  //         const list = sortedList.filter((item, i) =>
  //             i.toString() !== sourceElement.id)

  //         /* this is the removed item */
  //         const removed = sortedList.filter((item, i) =>
  //             i.toString() === sourceElement.id)[0]

  //         /* insert removed item after this number. */
  //         let insertAt = Number(event.target.id)

  //         console.log('list with item removed', list)
  //         console.log('removed:  line', removed)
  //         console.log('insertAt index', insertAt)
  //         console.log(list, removed, insertAt, "wdgeyeyyefdwfdw")

  //         let tempList = []

  //         /* if dropped at last item, don't increase target id by +1.
  //            max-index is arr.length */
  //         if (insertAt >= list.length) {
  //             tempList = list.slice(0).concat(removed)
  //             setSortedList(tempList)
  //             event.target.classList.remove('over')
  //         } else
  //             if ((insertAt < list.length)) {
  //                 /* original list without removed item until the index it was removed at */
  //                 tempList = list.slice(0, insertAt).concat(removed)

  //                 console.log('tempList', tempList)
  //                 console.log('insert the rest: ', list.slice(insertAt))

  //                 /* add the remaining items to the list */
  //                 const newList = tempList.concat(list.slice(
  //                     insertAt))
  //                 console.log('newList', newList)

  //                 /* set state to display on page */
  //                 setSortedList(newList)
  //                 event.target.classList.remove('over')
  //             }
  //     }
  //     else console.log('nothing happened')
  //     event.target.classList.remove('over')
  // }

  // const handleDragEnd = (event) => {
  //     event.target.style.opacity = 1
  // }

  const editeHandler = (data) => {
    setHeadername(data.displayName);
    setShowEdite(true);
    setEditValue(data.id);
  };
  const closeSaveHandler = () => {
    setShowEdite(false);
    setEditValue(null);
  };

  useEffect(() => {
    fetchComapnyHeaderList();
  }, []);

  const topViewNavData = {
    title: "Add Header",
    backPathRoute: "/dashboard",
    CompanyName: showCompname && showCompname,
  };
  return (
    <main className="contents__root expense_list">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "end",
              justifyContent: "space-between",
            }}
          >
            <TopViewNav topViewNavData={topViewNavData} />
          </Box>
        </Grid>

        <Grid item spacing={2} xs={12} className="AddheaderBox">
          <div className="headerlist">
            <div className="HeaderNameList">
              <p className="title" style={{ width: "230px" }}>
                S.No
              </p>
              <p className="title" style={{ width: "230px" }}>
                Actual Header Name
              </p>
              <p className="title" style={{ width: "230px" }}>
                Header Name
              </p>
              <p className="title" style={{ width: "230px" }}>
                Web Header Show
              </p>
              <p className="title" style={{ width: "230px" }}>
                Mobile Header Show
              </p>
              <p className="title" style={{ width: "230px" }}>
                Action
              </p>
            </div>

            {sortedList &&
              sortedList.map((header, ind) => {
                console.log(header, "headeruduef");
                return (
                  <>
                    <div className="item">
                      <p style={{ width: "230px" }}>{ind + 1}</p>
                      <p style={{ width: "230px" }} className="displayname">
                        {header && header.name ? header.name : "NA"}
                      </p>
                      <p style={{ width: "230px" }} className="displayname">
                        {showEditValue === true && editeValue === header.id ? (
                          <TextField
                            required
                            id="outlined-required"
                            label="Edit your  header"
                            variant="standard"
                            name="displayName"
                            value={header.displayName}
                            onChange={(e) => getOnchangevalue(e, ind)}
                          />
                        ) : (
                          header && header.displayName
                        )}
                      </p>

                      <p style={{ width: "230px" }}>
                        <Checkbox
                          color="primary"
                          name="isShowOnWeb"
                          value={header.isShowOnWeb}
                          disabled={header.isNotForWeb == true ? true : false}
                          onChange={(event) => getOnchangevalue1(event, ind)}
                          checked={header.isShowOnWeb}
                        />
                      </p>
                      <p style={{ width: "230px" }}>
                        <Checkbox
                          color="primary"
                          name="isShowOnApp"
                          value={header.isShowOnApp}
                          disabled={header.isNotForApp == true ? true : false}
                          onChange={(event) => getOnchangevalue1(event, ind)}
                          checked={header.isShowOnApp}
                        />
                      </p>
                      <p
                        style={{ width: "230px" }}
                        // style={{display:"flex",justifyContent:"center"}}
                      >
                        {/* {showEditValue === true && editeValue === header.id ?
                                                <Tooltip title="Save">
                                                    <IconButton style={{ color: "green" }}>
                                                        <SaveAsIcon onClick={() => EditSaveHandler(header)} />
                                                    </IconButton>
                                                </Tooltip> : ""
                                            } */}
                        {showEditValue === true && editeValue === header.id ? (
                          ""
                        ) : (
                          <Tooltip title="Edit Header">
                            <IconButton
                              style={{ color: "green" }}
                              onClick={() => editeHandler(header)}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                        {showEditValue === true && editeValue === header.id ? (
                          <Tooltip title="Close">
                            <IconButton
                              style={{ color: "red" }}
                              onClick={() => closeSaveHandler()}
                            >
                              <CloseIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          ""
                        )}
                      </p>
                    </div>
                  </>
                );
              })}
          </div>
        </Grid>
        {/* <Grid item spacing={2}>
                    <Grid 
                         sx={{ display: "flex", justifyContent: "flex-end", alignItems: "end", gap: "10px" }}>
                        <Button style={{ background: "red", color: "#fff" }}>
                            Cancel
                        </Button>
                        <Button style={{ background: "green", color: "#fff" }}>
                            Save
                        </Button>
                    </Grid>

                </Grid> */}
        <Grid item xs={12}>
          <Grid
            style={{
              placeItems: "center",
              display: "flex",
              gap: "10px",
              justifyContent: "flex-end",
              padding: "10px 0",
            }}
          >
            <div className="field_box">
              <div
                className="field_box_btn1"
                onClick={() => navigate(-1)}
                style={{
                  cursor: "pointer",
                  padding: "10px",
                }}
              >
                Cancel
              </div>
            </div>
            <div className="field_box">
              <div
                className="field_box_btn1"
                onClick={fetchCompanyUpdateList}
                style={{
                  cursor: "pointer",
                  padding: "10px",
                }}
              >
                Save
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </main>
  );
}

export default AddHeader;
